define('responsive-gameday/views/Monitor/ViewModels/distributors/FieldViewDistributor',['require','exports','module','GameDayCore','message-service/message-service','jquery','../../Events/SceneStateEvents','../../Events/ViewModelUpdateEvents','GameDayCore/GDModel/enums/datasources/Datasources','GameDayCore/GDUtil/dataMapping/NumberWithOrdinal','extant/extant'],function(require,exports,module) {
    var GDC = require("GameDayCore"),
        MessageService = require("message-service/message-service"),
        $ = require("jquery"),
        SceneStateEvents = require("../../Events/SceneStateEvents"),
        UpdateEvents = require("../../Events/ViewModelUpdateEvents"),
        Datasources = require("GameDayCore/GDModel/enums/datasources/Datasources"),
        NumberWithOrdinal = require("GameDayCore/GDUtil/dataMapping/NumberWithOrdinal"),
        exists = require("extant/extant");
        
    var gameData,
        stateUpdates,
        dataPack,
        gameInfo,
        plays,
        playerMap,
        stadium,
        hitchart,
        battingOrder,
        MAXHITLOCATIONRANGE = 255;

    exports.setGameData = function(game, scenes) {
        gameData = game;
        stateUpdates = scenes;

        gameInfo = gameData.game || gameData.linescore;
        plays = $.extend({}, gameData.play || gameData.linescore);
        playerMap = gameData.players && gameData.players.playerMap || {};
        stadium = gameInfo.stadium;

        MessageService.one(GDC.requestGameData(Datasources.HITCHART), function(payload, evt) {
            hitchart = $.extend({}, payload.hitchart);

            buildSendDataPack();
        });
    };

    exports.handleUpdateRequest = function() {
        gameData = GDC.getGameData();
        buildSendDataPack();
    };

    function buildSendDataPack() {
        dataPack = { 
            sport_code : gameData.linescore.home_sport_code
        };

        buildTeams();
        buildPlayers();
        buildVenue();
        buildHelperFunctions();

        MessageService.off(UpdateEvents.REQUEST_FIELD_VIEW_DATA,exports.handleUpdateRequest);
        MessageService.on.call(this,UpdateEvents.REQUEST_FIELD_VIEW_DATA,exports.handleUpdateRequest);
        MessageService.publish(UpdateEvents.UPDATE_FIELD_VIEW, dataPack);
    }

    function buildTeams() {
        $.extend(dataPack, {
            defense: plays.defense,
            offense: plays.offense || {},
            hits: {
                home: hitchart && hitchart.hits && hitchart.hits.home,
                away: hitchart && hitchart.hits && hitchart.hits.away
            }
        });
    }

    function buildPlayers() {
        if (plays.liveState === "Wrapup") {
            plays.waiting = null;
            if (exists(plays, "base,batter") && exists(plays, "base.batter")) {
                for (key in plays.base) {
                    if (plays.base[key].pid === plays.batter.pid) {
                        plays.batter = null;
                        break;
                    }
                }

                plays.base.batter = plays.base.batter || plays.batter;
            }
        }

        battingOrder = (plays.inning_state === "Bottom" || plays.inning_state === "Middle") ?
                        plays.homeBattingOrder : plays.awayBattingOrder;

        dataPack.waiting = {
            deck: plays.gameItem && plays.gameItem.getPlayerSnapshot(battingOrder[0], "b"),
            hole: plays.gameItem && plays.gameItem.getPlayerSnapshot(battingOrder[1], "b")
        }
    }

    function buildVenue()  {
        dataPack.venue = stadium.id && {
            name: stadium.name,
            id: stadium.id,
            location: stadium.location
        } || ''

    }

    function buildHelperFunctions() {
        $.extend(dataPack, {
            playerMap: playerMap,
            name: function () {
                var id = this.pid;
                return playerMap[id] && playerMap[id].boxname || '';
            },

            anchor: function () {
                var id = this.pid;
                return '<a href="#player=' + id + '">' + (playerMap[id] && playerMap[id].boxname || '') + '</a>';
            },

            fullname: function () {
                var id = this.pid;
                return playerMap[id] && (playerMap[id].first + " " + playerMap[id].last) || '';
            },

            playerVsPlayer: function () {
                var batterID = this.batter,
                    pitcherID = this.pitcher;
                return playerMap[batterID] &&
                       playerMap[pitcherID] &&
                       playerMap[batterID].last + " vs. " + playerMap[pitcherID].last || '';
            },

            playerFieldStats: function () {
                return this.s_po + " PO, " + this.s_ass + " A, " + this.s_err + " E, " + this.s_fldg + " FLDG%";
            },

            playerRunnerStats: function () {
                var batter = plays.gameItem && plays.gameItem.getPlayerSnapshot(this.pid, "b"),
                    stolenBases = batter && batter.sb ? batter.sb : "0",
                    caughtStealing = batter && batter.cs ? batter.cs : "0";
                return stolenBases + " SB, " + caughtStealing + " CS";
            },

            inningWithOrdinal: function () {
                return NumberWithOrdinal(this.inning);
            },

            top: function () {
                var top = parseFloat(this.y),
                    $hitLocationImage = $('.field .img');
                return top * ($hitLocationImage.height() / MAXHITLOCATIONRANGE);
            },

            left: function () {
                var left = parseFloat(this.x),
                    $hitLocationImage = $('.field .img');
                return left * ($hitLocationImage.width() / MAXHITLOCATIONRANGE);
            },

            hitOutMarkerClass: function() {
                return "hitoutdata-" + Math.floor(this.x) + "" + Math.floor(this.y) + "" + this.inning;
            }
        });
    }

});
